import API from '../../API';
import { makeAutoObservable } from 'mobx';

export class SPAuth {
	public serverConnectionLost: string | null = null;
	public spAuthRequired: boolean = false;
	public spAuthInProgress: boolean = false;
	public authWebUrl: string = '';

	private getToken: () => Promise<string>;
	private authStateChange: () => void;

	constructor(getToken: () => Promise<string>, authStateChange: () => void) {
		makeAutoObservable(this);
		this.getToken = getToken;
		this.authStateChange = authStateChange;
	}

	public cancelAuth() {
		this.spAuthRequired = false;
	}

	private setSPAuthRequired(spAuthRequired: boolean, authWebUrl: string) {
		this.spAuthRequired = spAuthRequired;
		this.authWebUrl = authWebUrl;
		this.spAuthInProgress = false;
		this.authStateChange();
	}

	private setServerConnectionLost(reason: string) {
		this.serverConnectionLost = reason;
	}

	public waitForSharePointPermissions() {
		this.spAuthInProgress = true;
		this.authStateChange();

		let attempts = 0;

		let interval = setInterval(() => {
			this.getToken().then((token) => {
				attempts++;
				new API(token).checkSPAuth(this.authWebUrl).then((result) => {
					console.log(
						`Auth attempt: ${attempts}, result: ${result.launchAuthenticationURL}`,
					);

					if (!result.launchAuthenticationURL) {
						clearInterval(interval);

						//Reload the window after 2 seconds.
						//There is a bug whereby the permissions sometimes don't take effect immediately.
						setTimeout(() => {
							window.location.reload();
						}, 30000);
					}
				});
			});

			if (attempts > 10) {
				clearInterval(interval);
				window.location.reload(); // Just try a reload anyway
			}
		}, 1000);
	}

	public startCheckSPAuth = (spUrl: string) => {
		this.authWebUrl = spUrl;
		this.getToken().then((token) => {
			new API(token)
				.checkSPAuth(this.authWebUrl)
				.then((result) => {
					this.setSPAuthRequired(result?.launchAuthenticationURL, result?.webUrl);
				})
				.catch((reason) => {
					console.log('Connection failure: ' + reason);
					this.setServerConnectionLost(reason);
				});
		});
	};
}
